/**
 * LabelCreator 模块化导出
 * 
 * 这个文件导出所有拆分后的hooks和utils，供原LabelCreator.js或其他组件使用
 * 
 * 使用方式：
 * 1. 保持原LabelCreator.js不变（已备份为LabelCreator.js.backup）
 * 2. 新功能可以直接import这些模块来构建
 * 3. 逐步迁移原组件到使用这些模块
 */

// 默认导出LabelCreator组件
import LabelCreator from './LabelCreator.jsx';

// Hooks
export { useLabelState } from './hooks/useLabelState';
export { useContentActions } from './hooks/useContentActions';

// Utils
export { 
  getDefaultDataForType,
  basicDefaults,
  templateDefaults 
} from './utils/contentDefaults';

export {
  getContentIcon,
  getContentName,
  basicContentTypes,
  templateTypes
} from './utils/contentTypes';

export {
  renderEditor,
  renderPreviewContent
} from './utils/renderHelpers';

export default LabelCreator;

